<div class="class-table-container">

  <p-table #ct
           [value]="classificationEstimates"
           [globalFilterFields]="['classificationCode', 'classificationDescription']"
           [scrollable]="true"
           scrollHeight="flex">
    <ng-template pTemplate="header"
                 let-columns>
      <tr>
        <th class="class-table-top-header"
            colspan="4">
          <i class="far fa-search"></i>
          <input class="input-filter"
                 type="text"
                 pInputText
                 size="50"
                 (input)="filterTable(ct, $event.target)" />
        </th>
      </tr>
      <tr>
        <th class="class-table-header"
            translate="TOOLBAR.CLASS"></th>
        <th class="class-table-sub-header"
            translate="MODAL.HOURS"></th>
        <th class="class-table-sub-header">
          {{ "TABLE.COSTING" | translate }} ({{ functionalCurrencySymbol }})
        </th>
        <th class="class-table-final-header">
          {{ "TABLE.SELLING" | translate }} ({{ functionalCurrencySymbol }})
        </th>
      </tr>
    </ng-template>
    <ng-template pTemplate="frozenbody"
                 let-rowData
                 let-columns="columns">
      <tr class="frozen-row">
        <td style="border-left: none">
          {{ rowData.classificationCode}} &#8901;
          {{ rowData.classificationDescription }}
        </td>
        <td style="text-align: right">
          {{ rowData.hours | number: "1.2-2":currentLang }}
        </td>
        <td style="text-align: right">
          {{ rowData.cost | number: "1.2-2":currentLang }}
        </td>
        <td style="border-right: none; text-align: right">
          {{ rowData.billable | number: "1.2-2":currentLang }}
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="body"
                 let-rowData
                 let-columns="columns">
      <tr [class.isAll]="rowData.classificationCode?.startsWith('#')">
        <td class="class-name-col">
          {{ rowData.classificationCode}} &#8901;
          {{ rowData.classificationDescription }}
        </td>
        <td class="class-table-col">
          {{ rowData.hours | number: "1.2-2":currentLang }}
        </td>
        <td class="class-table-col">
          {{ rowData.cost | number: "1.2-2":currentLang }}
        </td>
        <td class="class-final-col">
          {{ rowData.billable | number: "1.2-2":currentLang }}
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>
